import { DatabaseStreamState } from '@databases/rovo-bridge';
import { useEffect, useState } from 'react';

type DatabaseStreamHookState = {
  isStreaming: boolean;
  operationType?: 'create' | 'edit';
};

/**
 * A hook for observing the Databases streaming status from the bridge API by subscribing to DatabaseStreamState
 * Returns the latest { isStreaming, operationType }
 */
export const useDatabaseStreamState = (): DatabaseStreamHookState => {
  const [state, setState] = useState<DatabaseStreamHookState>(() => ({
    isStreaming: DatabaseStreamState.getInstance().isStreamingActive,
    operationType: 'create'
  }));

  useEffect(() => {
    const unsubscribe = DatabaseStreamState.getInstance().subscribe((s) => {
      setState({ isStreaming: s.isStreaming, operationType: s.operationType });
    });
    return unsubscribe;
  }, []);

  return state;
};
